(function () {
  const addButtonSelector = [
    '.product-form__submit',
    '.quick-add__submit',
    '[data-crafted-sticky-trigger]',
    'form[action*="/cart/add"] button[name="add"]',
    '[data-pf-type="ProductATC2"]',
  ].join(',');
  const colors = ['#c4975a', '#f6f3ed', '#8b5e3c', '#1f3d2e', '#e7ded0'];
  let lastTrigger = null;
  let lastTriggerTime = 0;

  function rememberTrigger(event) {
    if (!event.isTrusted) return;
    const trigger = event.target.closest(addButtonSelector);
    if (!trigger || trigger.disabled || trigger.getAttribute('aria-disabled') === 'true') return;
    lastTrigger = trigger;
    lastTriggerTime = Date.now();
  }

  function createConfetti(trigger) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const bounds = trigger.getBoundingClientRect();
    const originX = bounds.left + bounds.width / 2;
    const originY = bounds.top + bounds.height / 2;
    const layer = document.createElement('div');
    layer.className = 'crafted-confetti';
    layer.setAttribute('aria-hidden', 'true');

    for (let index = 0; index < 30; index += 1) {
      const angle = ((205 + Math.random() * 130) * Math.PI) / 180;
      const distance = 105 + Math.random() * 120;
      const endX = Math.cos(angle) * distance;
      const endY = Math.sin(angle) * distance + 125 + Math.random() * 45;
      const piece = document.createElement('span');
      const rotation = 180 + Math.round(Math.random() * 540);

      piece.className = 'crafted-confetti__piece';
      piece.style.setProperty('--crafted-confetti-x', `${originX}px`);
      piece.style.setProperty('--crafted-confetti-y', `${originY}px`);
      piece.style.setProperty('--crafted-confetti-mid-x', `${endX * 0.62}px`);
      piece.style.setProperty('--crafted-confetti-mid-y', `${endY * 0.48 - 65}px`);
      piece.style.setProperty('--crafted-confetti-end-x', `${endX}px`);
      piece.style.setProperty('--crafted-confetti-end-y', `${endY}px`);
      piece.style.setProperty('--crafted-confetti-rotate-mid', `${rotation * 0.55}deg`);
      piece.style.setProperty('--crafted-confetti-rotate-end', `${rotation}deg`);
      piece.style.setProperty('--crafted-confetti-size', `${3 + Math.random() * 3}px`);
      piece.style.setProperty('--crafted-confetti-color', colors[index % colors.length]);
      piece.style.animationDelay = `${Math.random() * 100}ms`;
      layer.appendChild(piece);
    }

    document.body.appendChild(layer);
    window.setTimeout(() => layer.remove(), 1500);
  }

  function celebrateSuccessfulAdd() {
    if (!lastTrigger || Date.now() - lastTriggerTime > 10000) return;
    createConfetti(lastTrigger);
    lastTrigger = null;
    lastTriggerTime = 0;
  }

  document.addEventListener('click', rememberTrigger, true);
  document.addEventListener('cart:update', celebrateSuccessfulAdd);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, celebrateSuccessfulAdd);
  }
})();
